class Utils {
    constructor() {}

    formatDate(date, format) {
        if (date.indexOf('.') !== -1 && format === 'Y-m-d') {
            const dateParts = date.split('.');
            return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        }

        date = new Date(date);
        const year = date.getFullYear();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let hour = date.getHours();
        let minute = date.getMinutes();

        if (day < 10) {
            day = '0' + day;
        }

        if (month < 10) {
            month = '0' + month;
        }

        if (hour < 10) {
            hour = '0' + hour;
        }

        if (minute < 10) {
            minute = '0' + minute;
        }

        if (format === 'd.m.Y') {
            return `${day}.${month}.${year}`;
        } else if (format === 'd.m.') {
            return `${day}.${month}`;
        } else if (format === 'd.m. H:i') {
            return `${day}.${month} ${hour}:${minute}`;
        } else {
            return `${year}-${month}-${day}`;
        }
    }

    customEventPolyfill(event) {
        if (typeof window.CustomEvent === "function") {
            if (typeof window.Event === "function") {
                return new Event(event);
            }
        }

        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, false, false, null);
        return evt;
    }
}

export default Utils;
